import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { LOAD_MORE_BUTTON_TEXT } from '@/shared/constants';
import styles from './LoadMoreButton.module.scss';

type LoadMoreButtonProps = {
  onClick: () => void;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export const LoadMoreButton = ({ onClick, className, ...rest }: LoadMoreButtonProps) => {
  return (
    <div
      {...rest}
      className={[styles.loadMoreButton, className && className]
        .filter(Boolean)
        .join(' ')}
    >
      <div className={styles.wrapper}>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={onClick}>
            {LOAD_MORE_BUTTON_TEXT}
          </button>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M12.4425 6.22266L9 9.65766L5.5575 6.22266L4.5 7.28016L9 11.7802L13.5 7.28016L12.4425 6.22266Z"
            fill="#1A1A1A"
          />
        </svg>
      </div>
    </div>
  );
};
